module.exports = "<div id=version-number ng-if=$ctrl.isVisible> <p> <small>{{ $ctrl.version }}</small> </p> </div> ";